<template lang="pug">
#ic_selector(v-show="pageShow")
  .jumbotron.jumbotron-fluid.text-white.bg-dark.mb-0.pb-0(
    v-if="icSelectorInformation.photo",
    :style="{ backgroundImage: 'url(' + icSelectorInformation.photo.image + ')' }"
  )
    .container
      .row.justify-content-center
        .col-md-8
          .title.text-center.pt-3.mb-4
            h4.text-white.mb-4 {{ title }}
            .specification.border.rounded.p-2
              h3.text-white.mb-0
                | Sensor Pitch :
                span {{ searchResult.result }}
                | mm
          h3.text-white.text-center.mb-4 Recommended PCAP Solutions :
          .row.solutions
            .col-md-6
              .bg-white.shadow.text-center.h-100.Lightbox-1
                h3.bg-light.p-2.mb-0 IC
                .py-2.px-3
                  item(
                    v-for="(item, index) in searchResult.ics.slice(0, 5)",
                    :key="index",
                    :title="item.name",
                    @click.native="() => showImg(item)"
                  )

                  vue-easy-lightbox(
                    :visible="visible",
                    :imgs="currentImgs",
                    :index="index",
                    moveDisabled,
                    @hide="handleHide",
                    @on-prev-click="prev",
                    @on-next-click="next"
                  )

            .col-md-6
              .bg-white.shadow.text-center.h-100.Lightbox-2
                h3.bg-light.p-2.mb-0 Controller Board
                .py-2.px-3
                  item(
                    v-for="(item, index) in searchResult.controller_boards.slice(0, 5)",
                    :key="index",
                    :title="item.name",
                    @click.native="() => showImg(item)"
                  )

                  vue-easy-lightbox(
                    :visible="visible",
                    :imgs="currentImgs",
                    :index="index",
                    moveDisabled,
                    @hide="handleHide",
                    @on-prev-click="prev",
                    @on-next-click="next"
                  )
  .pt-5.bg-light
    .container
      .row.justify-content-center.my-3.py-5
        .col-md-8.text-center
          h2.mb-5 What add-on touch features you need , EETI could help!
          a#clickhere.btn.btn-warning(@click="expand") {{ isFormExpand ? 'Fold Here' : 'Need More Feature' }}
          form.help-checkbox(ref="formmore")
            .row.mt-4.text-left
              .col-md-6.mb-3(
                v-for="(checkbox, index) in formCheckBoxs",
                :key="index"
              )
                .custom-control.custom-checkbox.border.bg-white.p-2
                  input.custom-control-input(
                    v-model="touchFeaturesSelect",
                    :id="checkbox.id",
                    :value="checkbox.id",
                    type="checkbox"
                  )
                  label.custom-control-label(:for="checkbox.id") {{ checkbox.name }}
            button.btn.btn-primary(@click="submitData", type="button") Submit
    .py-5.bg-primary
      .container.my-3
        .selector-help.row
          .col-md-6.mb-2(v-for="aviation in aviationList")
            aviation(
              style="cursor: pointer",
              :title="aviation.title",
              :img="aviation.photo ? aviation.photo.image : null",
              @click.native="aviationClick(aviation)"
            )
        banner.mt-4(v-if="pageShow", :bannerList="bannerList")
  float-actions
  float-top
  .PCAP-IC-selector.d-block.d-sm-none
    a.shadow-sm(
      v-b-modal.dialog="",
      @click="$bvModal.show('selectorModal')",
      data-toggle="modal",
      data-target="#selectorModal"
    )
      font-awesome-icon.i_mr_1(:icon="['fas', 'search']") 
      | PCAP IC selector
  custom-footer
  p.counter(v-if="visible") {{ index + 1 }}/{{ currentImgs.length }}
  dialog-text(
    :title="dialogData.title",
    :divider="true",
    :contentCenter="true"
  )
    template(#content)
      img.text-center.my-3(:src="dialogData.icon", height="40")
      p {{ dialogData.text }}
  dialog-login
</template>

<script>
import Velocity from "velocity-animate";
import Footer from "@/components/home/Footer";
import FloatTop from "@/components/common/FloatTop";
import FloatActions from "@/components/common/FloatActions";
import Item from "@/components/ic_selector/Item";
import Banner from "@/components/ic_selector/Banner";
import Aviation from "@/components/ic_selector/Aviation";
import MailIcon from "@/assets/img/register/mail.gif";
import DialogText from "@/components/common/DialogText";
import { getIcSelector, getTouchFeatureList } from "@/api/ic_selector";
import { getBannerList } from "@/api/company";
import { searchICSelector } from "@/api/product";
import { submitContactData } from "@/api/user";
import { mixins } from "@/mixins/mixins.js";
import DialogLogin from "@/components/common/DialogLogin";

export default {
  name: "IcSelector",
  metaInfo() {
    return {
      title: this.metaData.title,
    };
  },
  mixins: [mixins],
  components: {
    "custom-footer": Footer,
    "float-top": FloatTop,
    "float-actions": FloatActions,
    item: Item,
    banner: Banner,
    aviation: Aviation,
    DialogText,
    DialogLogin,
  },
  data() {
    return {
      pageShow: false,
      dialogData: {
        title: "Successfully sent",
        icon: MailIcon,
        text:
          "Has been sent successfully, we will reply you as soon as possible.",
      },
      visible: false,
      index: 0, // default: 0
      aviationList: [],
      formCheckBoxs: [],
      isFormExpand: false,

      icSelectorInformation: {},

      title:
        "",

      searchResult: {},

      currentImgs: [],

      touchFeaturesSelect: [],

      bannerList: [],

      metaData: {
        title: "PCAP IC Solution Selector ｜EETI recommend your TouchSystem",
      },
    };
  },
  watch: {
    "$store.state.user.language"() {
      this.initialLanguage();
    },
  },
  created() {
    this.initialLanguage();
    this.searchICSelector();
  },
  methods: {
    initialLanguage() {
      this.aviationList = [];
      this.getBannerList();
      this.getIcSelector();
      this.getTouchFeatureList();
    },
    expand() {
      this.isFormExpand = !this.isFormExpand;

      if (this.isFormExpand) {
        var height = this.$refs.formmore.scrollHeight;

        Velocity(this.$refs.formmore, { maxHeight: height }, { duration: 200 });
      } else {
        Velocity(this.$refs.formmore, { maxHeight: 0 }, { duration: 200 });
      }
    },

    showImg(item) {
      this.currentImgs = [];
      for (let index in item.photos) {
        let temp = item.photos[index];
        this.currentImgs.push(temp.image);
      }
      this.index = 0;
      this.visible = true;
    },
    handleHide() {
      this.visible = false;
    },
    prev(oldIndex, newIndex) {
      this.index = newIndex;
    },
    next(oldIndex, newIndex) {
      this.index = newIndex;
    },
    getIcSelector() {
      let temp = {
        lang: this.$store.state.user.language,
      };
      getIcSelector(temp).then((response) => {
        this.icSelectorInformation = response.data;
        this.aviationList = [];
        let left = {
          photo: this.icSelectorInformation.lower_left_photo,
          title: this.icSelectorInformation.lower_left_text,
          link: this.icSelectorInformation.lower_left_link,
        };
        this.aviationList.push(left);
        let right = {
          photo: this.icSelectorInformation.lower_right_photo,
          title: this.icSelectorInformation.lower_right_text,
          link: this.icSelectorInformation.lower_right_link,
        };
        this.aviationList.push(right);
        this.pageShow = true;
      });
    },
    getTouchFeatureList() {
      let temp = {
        lang: this.$store.state.user.language,
      };
      getTouchFeatureList(temp).then((response) => {
        this.formCheckBoxs = response.data;
      });
    },
    getBannerList() {
      let temp = {
        lang: this.$store.state.user.language,
      };
      getBannerList(temp).then((response) => {
        this.bannerList = response.data;
      });
    },
    searchICSelector() {
      searchICSelector(this.$route.query).then((response) => {
        this.searchResult = response.data;
      });
    },
    submitData() {
      if (this.$store.state.user.accessToken) {
        let temp = {
          panel_size: this.$route.query.panel_size,
          active_area_x: this.$route.query.active_area_x,
          active_area_y: this.$route.query.active_area_y,
          channel_x: this.$route.query.channel_x,
          channel_y: this.$route.query.channel_y,
          sensor_pitch: this.searchResult.result,
        };
        let data = {
          page: "ic-selector",
          content: JSON.stringify(temp),
          ics: this.searchResult.ics.map((item) => {
            return item.id;
          }),
          controller_boards: this.searchResult.controller_boards.map((item) => {
            return item.id;
          }),
          touch_features: this.touchFeaturesSelect,
        };

        submitContactData(data).then(() => {
          this.showTextDialog();
        });
      } else {
        this.$bvModal.show("loginModal");
      }
    },
    showTextDialog() {
      this.$bvModal.show("textModal");
    },
    aviationClick(aviation) {
      this.linkClick(aviation.link);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/ic_selector/ic_selector";

::v-deep .vel-img-modal.vel-modal {
  background: rgba(255, 255, 255, 0.5);
}

::v-deep .vel-btns-wrapper .btn__close,
.vel-btns-wrapper .btn__next,
.vel-btns-wrapper .btn__prev {
  color: #000;
}

::v-deep .vel-toolbar {
  .toobar-btn.toolbar-btn__zoomin,
  .toobar-btn.toolbar-btn__zoomout,
  .toobar-btn.toolbar-btn__resize,
  .toobar-btn.toolbar-btn__rotate,
  .toobar-btn.toolbar-btn__rotate {
    background-color: #fff;

    &:hover {
      background-color: rgb(223, 223, 223);
    }
  }
}

::v-deep svg.vel-icon.icon {
  color: #000;
}

p.counter {
  top: 10px;
  left: 10px;
  z-index: 10000;
  position: fixed;
  top: 0;
}
</style>
